class DeliveryRegionRoutingEditController {
    /*@ngInject*/

    constructor(User, $state) {
        this.User = User;
        this.$state = $state;
        this.hasAcl = {};
        this.model = {
            branch: User.getUser().branchId
        }
    }

    $onInit() {
        console.log('Edit');
    }
};

export default DeliveryRegionRoutingEditController;


// WEBPACK FOOTER //
// ./client/app/components/delivery_region_routing/edit/delivery_region_routing.edit.controller.js